<!-- @format -->
@if (showHeader) {
  <div id="stylitics-header-container">
    <h2 class="stylitics-header description-header hmf-flex-grow">Shop The Set</h2>
    <hr/>
  </div>
}
<div id="stylitics-composer-container"></div>